// @ts-nocheck
// Console admin do Forjamente — dashboard SaaS completo, separado do app
// normal. Acessível apenas pra role=admin (Wesley) via rota /admin.
//
// Layout desktop-first com sidebar fixa + content area. Em mobile vira stack
// vertical (sidebar colapsável). Cores escuras pra diferenciar do app user.
//
// Seções:
//   - Visão geral: KPIs + atividade recente
//   - Usuários: tabela de usuários do leitura (via leitura_users)
//   - Grupos: gestão consolidada
//   - Receita: distribuição de planos, MRR, churn
//   - Suporte: placeholder pra reclamações/alertas (futuro)
import React, { useState, useEffect } from 'react';
import { Icon } from '../icons';
import { api } from '../../services/apiV2';
import { PLAN_NAMES } from '../plans';

const SECTIONS = [
  { id: 'overview',  label: 'Visão geral', icon: 'chart' },
  { id: 'users',     label: 'Usuários',    icon: 'user' },
  { id: 'clubs',     label: 'Grupos',      icon: 'users' },
  { id: 'referrals', label: 'Indicações',  icon: 'users' },
  { id: 'revenue',   label: 'Receita',     icon: 'sparkle' },
  { id: 'plans',     label: 'Planos',      icon: 'edit' },
  { id: 'billing',   label: 'Cobranças',   icon: 'check' },
  { id: 'support',   label: 'Suporte',     icon: 'mail' },
] as const;

export const AdminConsoleScreen: React.FC<{
  session: any;
  onBack: () => void;
}> = ({ session, onBack }) => {
  const [active, setActive] = useState<string>('overview');
  const [overview, setOverview] = useState<any>(null);
  const [timeseries, setTimeseries] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [clubs, setClubs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadAll = async () => {
    if (!session) return;
    setLoading(true);
    setError(null);
    try {
      const [ov, ts, us, cl] = await Promise.all([
        api.adminDashboard(session).catch(e => ({ _error: e?.message })),
        api.adminTimeseries(session, 30).catch(() => ({ series: [] })),
        fetch('/api/admin/users', { headers: { Authorization: `Bearer ${session.accessToken}` } }).then(r => r.json()).catch(() => []),
        api.adminListClubs(session).catch(() => ({ clubs: [] })),
      ]);
      if (ov?._error) setError(ov._error);
      else setOverview(ov);
      setTimeseries(ts.series || []);
      setUsers(Array.isArray(us) ? us : (us.users || []));
      setClubs(cl.clubs || []);
    } catch (e: any) {
      setError(e?.message || 'Erro ao carregar console');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadAll(); /* eslint-disable-next-line */ }, [session]);

  return (
    // Console é full-screen desktop, ESCAPA do .app-shell (max-width: 480) usando
    // position: fixed; inset: 0. Layout próprio com sidebar fixa à esquerda
    // e conteúdo principal full-width à direita.
    <div style={{
      position: 'fixed', inset: 0, zIndex: 200,
      background: '#0E0B09', color: '#F5F1EA',
      display: 'flex', flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      overflow: 'hidden',
    }}>
      {/* Header top */}
      <header style={{
        padding: '16px 32px',
        borderBottom: '1px solid rgba(245,241,234,0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: '#0A0806', position: 'sticky', top: 0, zIndex: 10,
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <button onClick={onBack} style={{
            width: 32, height: 32, borderRadius: '50%',
            background: 'rgba(245,241,234,0.08)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: 'none', cursor: 'pointer', color: '#F5F1EA',
          }}>
            <Icon name="chevron-left" size={14} color="#F5F1EA"/>
          </button>
          <div>
            <div className="mono" style={{
              fontSize: 9.5, letterSpacing: '0.20em', textTransform: 'uppercase',
              color: '#E87A3B', fontWeight: 600,
            }}>FORJAMENTE · CONSOLE</div>
            <div className="serif" style={{ fontSize: 22, lineHeight: 1.05, marginTop: 2 }}>
              Painel <span style={{ fontStyle: 'italic', color: '#E87A3B' }}>admin</span>
            </div>
          </div>
        </div>
        <button onClick={loadAll} disabled={loading} style={{
          padding: '8px 14px', borderRadius: 999,
          background: loading ? 'rgba(245,241,234,0.08)' : 'rgba(232,122,59,0.15)',
          border: '1px solid ' + (loading ? 'rgba(245,241,234,0.1)' : 'rgba(232,122,59,0.4)'),
          color: loading ? 'rgba(245,241,234,0.5)' : '#E87A3B',
          fontSize: 12, fontWeight: 500, cursor: loading ? 'default' : 'pointer',
          fontFamily: 'inherit',
        }}>
          {loading ? 'Atualizando…' : '↻ Atualizar'}
        </button>
      </header>

      <div style={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {/* Sidebar fixa à esquerda */}
        <aside style={{
          width: 240, padding: '24px 16px',
          borderRight: '1px solid rgba(245,241,234,0.08)',
          background: '#0A0806',
          flexShrink: 0,
          display: 'flex', flexDirection: 'column', gap: 4,
          overflowY: 'auto',
        }}>
          {SECTIONS.map(s => (
            <button
              key={s.id}
              onClick={() => setActive(s.id)}
              style={{
                width: '100%', padding: '10px 14px', borderRadius: 10,
                background: active === s.id ? 'rgba(232,122,59,0.15)' : 'transparent',
                border: '1px solid ' + (active === s.id ? 'rgba(232,122,59,0.35)' : 'transparent'),
                color: active === s.id ? '#E87A3B' : 'rgba(245,241,234,0.7)',
                display: 'flex', alignItems: 'center', gap: 10,
                fontSize: 13, fontWeight: active === s.id ? 600 : 400,
                cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left',
                transition: 'all 160ms',
              }}
            >
              <Icon name={s.icon} size={14} color={active === s.id ? '#E87A3B' : 'rgba(245,241,234,0.55)'}/>
              {s.label}
            </button>
          ))}
        </aside>

        {/* Content full-width — usa todo espaço disponível, max 1400px pra não esticar demais em telas 4K */}
        <main style={{
          flex: 1, padding: '32px 40px',
          overflowY: 'auto', overflowX: 'hidden',
          minWidth: 0,
        }}>
          <div style={{ maxWidth: 1400, margin: '0 auto', width: '100%' }}>
          {error && (
            <div style={{
              padding: 14, borderRadius: 10, marginBottom: 16,
              background: 'rgba(232,122,59,0.15)',
              border: '1px solid rgba(232,122,59,0.4)',
              color: '#E87A3B', fontSize: 13,
            }}>{error}</div>
          )}

          {loading && !overview && (
            <div style={{ padding: 40, textAlign: 'center', color: 'rgba(245,241,234,0.5)', fontSize: 13 }}>
              Carregando dados…
            </div>
          )}

          {active === 'overview' && overview && (
            <OverviewSection overview={overview} timeseries={timeseries}/>
          )}
          {active === 'users' && (
            <UsersSection users={users}/>
          )}
          {active === 'clubs' && (
            <ClubsSection clubs={clubs}/>
          )}
          {active === 'referrals' && (
            <ReferralsSection session={session}/>
          )}
          {active === 'revenue' && overview && (
            <RevenueSection overview={overview}/>
          )}
          {active === 'plans' && (
            <PlansSection session={session}/>
          )}
          {active === 'billing' && (
            <BillingSection session={session}/>
          )}
          {active === 'support' && (
            <SupportSection/>
          )}
          </div>
        </main>
      </div>
    </div>
  );
};

// ───────────────────────────────────────────────────────────────────
// VISÃO GERAL
// ───────────────────────────────────────────────────────────────────
const OverviewSection: React.FC<{ overview: any; timeseries: any[] }> = ({ overview, timeseries }) => {
  const fmtBRL = (v: number) => `R$ ${(v || 0).toFixed(2).replace('.', ',')}`;
  // null = nao apuravel (sem base de comparacao). Mostrar "—" em vez de um
  // numero escolhido: "+100%" sem base se confunde com crescimento medido.
  const fmtPct = (v: number | null | undefined) =>
    (v === null || v === undefined) ? '—' : `${v >= 0 ? '+' : ''}${v}%`;
  const pct = (v: number | null | undefined) =>
    (v === null || v === undefined) ? '—' : `${v}%`;
  return (
    <div>
      {/* Linha 1: KPIs principais */}
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: '#E87A3B', fontWeight: 600, marginBottom: 12,
      }}>Indicadores · retrato de agora</div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 14,
      }}>
        <KPI
          label="Usuários"
          value={overview.users.total}
          sub={`${overview.users.new30d} novos · ${fmtPct(overview.users.growth30d)}`}
          tooltip="Total de usuários cadastrados no Forjamente. Sub-linha: novos cadastros nos últimos 30 dias e crescimento % vs 30 dias anteriores."
        />
        <KPI
          label="MRR"
          value={fmtBRL(overview.revenue.mrr)}
          sub={(() => {
            const base = `${overview.revenue.payingUsersReal ?? 0} pagantes · ${pct(overview.revenue.conversionRate)} conv.`;
            // Sem isto, um MRR zerado por vencimento leria como "ninguem pagou".
            const venc = overview.revenue.pagamentosVencidos || 0;
            const semP = overview.revenue.assinaturasSemPagamento || 0;
            const extra = [
              venc ? `${venc} fora da janela` : null,
              semP ? `${semP} sem pagamento` : null,
            ].filter(Boolean).join(' · ');
            return extra ? `${base} · ${extra}` : base;
          })()}
          tooltip="Monthly Recurring Revenue: receita BRUTA mensal recorrente. Soma o último pagamento confirmado de cada assinante ativo, normalizado pra mensal (anuais ÷ 12). Só entra pagamento dentro da janela do ciclo — mensal até 45 dias, anual até 400. Fora disso não é receita corrente, é histórico. Reembolso, chargeback ou cancelamento posterior zeram o usuário. Não estima valor por tabela de preço: sem pagamento confirmado, sem MRR."
          accent
        />
        <KPI
          label="NRR (líquido)"
          value={fmtBRL(overview.revenue.nrr ?? 0)}
          sub={`taxa ${overview.revenue.feesPct ?? 0}% · ${fmtBRL((overview.revenue.mrr || 0) - (overview.revenue.nrr || 0))}/mês em taxas`}
          tooltip="Net Recurring Revenue: receita mensal depois da taxa do gateway. Usa o `netValue` informado pelo próprio gateway na transação. Quando a transação não traz netValue, o líquido assume o valor bruto — o NRR fica igual ao MRR e a taxa aparece como 0%, em vez de exibir um percentual estimado com cara de medido."
        />
        <KPI
          label="ARR (proj. anual)"
          value={fmtBRL(overview.revenue.arr ?? 0)}
          sub={`bruto · líquido ${fmtBRL(overview.revenue.nar ?? 0)}`}
          tooltip="Annual Recurring Revenue: projeção da receita anual baseada no MRR atual (MRR × 12). Bruto = ARR (com taxas). Líquido = NAR = NRR × 12 (após as taxas do gateway). Útil pra estimar receita anual recorrente sem precisar esperar 12 meses."
        />
        <KPI
          label="MAU"
          value={overview.engagement.mau}
          sub={`DAU ${overview.engagement.dau} · WAU ${overview.engagement.wau}`}
          tooltip="Monthly Active Users: usuários que registraram alguma leitura nos últimos 30 dias. DAU = ativos hoje · WAU = ativos na última semana."
        />
        <KPI
          label="Leitores parados 30d"
          value={pct(overview.retention.churnRate)}
          sub={overview.retention.totalReaders
            ? `${overview.retention.readersParados30d ?? 0} de ${overview.retention.totalReaders} leitores`
            : 'nenhum leitor ainda'}
          tooltip="De quem já registrou leitura alguma vez, quantos não registraram nos últimos 30 dias. NÃO é churn de assinatura: ninguém aqui cancelou nada, apenas parou de ler. O sub-texto mostra exatamente a fração que gera o percentual."
          tone={overview.retention.churnRate === null ? 'default'
              : overview.retention.churnRate > 50 ? 'error'
              : overview.retention.churnRate > 25 ? 'warn' : 'default'}
        />
        <KPI
          label="Grupos ativos"
          value={overview.clubs.active}
          sub={`${overview.clubs.new30d} novos`}
          tooltip="Total de clubes/grupos não-deletados na plataforma. Sub-linha: criados nos últimos 30 dias."
        />
        <KPI
          label="Posts 30d"
          value={overview.community.posts30d}
          sub={`${overview.community.posts7d} esta semana`}
          tooltip="Posts criados em clubes nos últimos 30 dias (qualquer tipo: reflexão, citação, pergunta, quiz, caixa de perguntas, insight final)."
        />
      </div>

      {/* Linha 1.5: detalhamento de receita — pagantes reais vs admin override */}
      {overview.revenue.payingUsersGranted > 0 && (
        <div style={{
          marginTop: 14, padding: 12, borderRadius: 10,
          background: 'rgba(232,122,59,0.06)', border: '1px solid rgba(232,122,59,0.18)',
          fontSize: 11.5, color: 'rgba(245,241,234,0.7)', lineHeight: 1.5,
        }}>
          <strong style={{ color: '#E87A3B' }}>Detalhe da receita:</strong> dos {overview.revenue.payingUsers} usuários com plano pago, {overview.revenue.payingUsersReal ?? 0} são <strong>pagantes reais</strong> (com transação confirmada gerando MRR) e {overview.revenue.payingUsersGranted} foram <strong>concedidos pelo admin</strong> (sem cobrança recorrente).
        </div>
      )}

      {/* Linha 2: cards de INATIVIDADE — % de usuários sem atividade por janela */}
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: '#E87A3B', fontWeight: 600, marginTop: 28, marginBottom: 12,
      }}>Inatividade · sem registrar leitura ou abrir o app</div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 14,
      }}>
        {(['d3','d7','d15','d30'] as const).map((k) => {
          const win = overview.retention.inactive?.[k];
          if (!win) return null;
          const days = k.slice(1);
          // Cor proporcional à severidade — quanto mais % inativo, mais quente
          // sem base, tom neutro: verde de 'success' leria como otimo
          const tone = win.pct === null ? 'default'
            : win.pct >= 70 ? 'error' : win.pct >= 40 ? 'warn' : 'success';
          return (
            <KPI
              key={k}
              label={`Inativos ${days}d`}
              value={pct(win.pct)}
              sub={`${win.count} de ${overview.users.total}`}
              tooltip={`% de usuários que NÃO tiveram nenhuma atividade (leitura registrada OU abertura do app) nos últimos ${days} dias. ${overview.retention.neverActive ? `Inclui ${overview.retention.neverActive} que nunca abriu o app desde signup.` : ''}`}
              tone={tone}
            />
          );
        })}
      </div>

      {/* Linha 2: Timeseries + Atividade recente lado a lado em desktop largo */}
      <div style={{
        marginTop: 28,
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
        gap: 14,
      }}>
        <div>
          <div className="mono" style={{
            fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
            color: '#E87A3B', fontWeight: 600, marginBottom: 10,
          }}>Atividade diária · 30 dias</div>
          <Timeseries data={timeseries}/>
        </div>
        <div>
        <div className="mono" style={{
          fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
          color: '#E87A3B', fontWeight: 600, marginBottom: 10,
        }}>Atividade recente</div>
        <div style={{
          background: 'rgba(245,241,234,0.03)', borderRadius: 12,
          border: '1px solid rgba(245,241,234,0.08)', overflow: 'hidden',
          maxHeight: 480, overflowY: 'auto',
        }}>
          {(overview.recentActivity || []).map((a: any, i: number, arr: any[]) => (
            <div key={i} style={{
              padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 12,
              borderBottom: i < arr.length - 1 ? '1px solid rgba(245,241,234,0.06)' : 'none',
              fontSize: 12.5,
            }}>
              <span style={{
                width: 60, fontFamily: 'Geist Mono, monospace', fontSize: 10,
                color: 'rgba(245,241,234,0.45)', flexShrink: 0,
              }}>{new Date(a.at).toLocaleString('pt-BR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
              <span style={{
                fontFamily: 'Geist Mono, monospace', fontSize: 9.5,
                padding: '2px 7px', borderRadius: 4,
                background: a.kind === 'signup' ? 'rgba(74,138,90,0.2)'
                          : a.kind === 'club_created' ? 'rgba(232,122,59,0.2)'
                          : 'rgba(245,241,234,0.08)',
                color: a.kind === 'signup' ? '#7DB48A'
                     : a.kind === 'club_created' ? '#E87A3B'
                     : 'rgba(245,241,234,0.65)',
                letterSpacing: '0.10em', textTransform: 'uppercase', fontWeight: 600,
                flexShrink: 0,
              }}>
                {a.kind === 'signup' ? 'novo' : a.kind === 'club_created' ? 'grupo' : a.postKind || 'post'}
              </span>
              <span style={{ color: 'rgba(245,241,234,0.85)' }}>
                {a.kind === 'signup' && <>{a.name} ({a.email}) · {a.source}</>}
                {a.kind === 'club_created' && <>{a.ownerName} criou grupo · {a.mode} · {a.privacy}</>}
                {a.kind === 'post' && <>{a.authorName} postou {a.postKind}</>}
              </span>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  );
};

// KPI card com tooltip explicativo (info icon clicável que mostra mini legenda)
const KPI: React.FC<{
  label: string;
  value: any;
  sub?: string;
  accent?: boolean;
  /** Texto curto explicando o que esse número significa, mostrado abaixo
   *  quando user hovera/clica no ícone de info. */
  tooltip?: string;
  /** Cor especial (success/warn/error) — pra cards de inatividade etc. */
  tone?: 'default' | 'success' | 'warn' | 'error';
}> = ({ label, value, sub, accent, tooltip, tone = 'default' }) => {
  const [showTip, setShowTip] = useState(false);
  const toneColor = {
    default: 'rgba(245,241,234,0.55)',
    success: '#7DB48A',
    warn: '#E0B86C',
    error: '#E87A3B',
  }[tone];
  const toneBg = {
    default: 'rgba(245,241,234,0.04)',
    success: 'rgba(74,138,90,0.10)',
    warn: 'rgba(224,184,108,0.10)',
    error: 'rgba(232,122,59,0.12)',
  }[tone];
  const toneBorder = {
    default: 'rgba(245,241,234,0.08)',
    success: 'rgba(74,138,90,0.3)',
    warn: 'rgba(224,184,108,0.3)',
    error: 'rgba(232,122,59,0.35)',
  }[tone];
  return (
    <div style={{
      padding: 16, borderRadius: 12, position: 'relative',
      background: accent ? 'linear-gradient(135deg, rgba(232,122,59,0.18), rgba(199,83,26,0.06))' : toneBg,
      border: '1px solid ' + (accent ? 'rgba(232,122,59,0.4)' : toneBorder),
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <div className="mono" style={{
          fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase',
          color: accent ? '#E87A3B' : toneColor, fontWeight: 600,
        }}>{label}</div>
        {tooltip && (
          <button
            onClick={() => setShowTip(v => !v)}
            onMouseEnter={() => setShowTip(true)}
            onMouseLeave={() => setShowTip(false)}
            aria-label="Ver explicação"
            style={{
              width: 16, height: 16, borderRadius: '50%',
              background: 'rgba(245,241,234,0.10)',
              border: '1px solid rgba(245,241,234,0.18)',
              color: 'rgba(245,241,234,0.55)',
              fontSize: 10, lineHeight: 1, fontWeight: 600,
              cursor: 'help', fontFamily: 'inherit',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}
          >?</button>
        )}
      </div>
      <div className="serif" style={{ fontSize: 32, lineHeight: 1, marginTop: 8, color: '#F5F1EA' }}>
        {value}
      </div>
      {sub && (
        <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.55)', marginTop: 6, fontFamily: 'Geist Mono, monospace', letterSpacing: '0.04em' }}>
          {sub}
        </div>
      )}
      {tooltip && showTip && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 6, zIndex: 50,
          padding: 10, borderRadius: 8,
          background: 'rgba(10,8,6,0.96)', border: '1px solid rgba(245,241,234,0.15)',
          color: 'rgba(245,241,234,0.85)', fontSize: 11.5, lineHeight: 1.45,
          boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
        }}>{tooltip}</div>
      )}
    </div>
  );
};

// SVG line chart simples — sem deps, plota signups + posts da timeseries
const Timeseries: React.FC<{ data: any[] }> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div style={{ padding: 30, textAlign: 'center', color: 'rgba(245,241,234,0.4)', fontSize: 12 }}>Sem dados</div>;
  }
  const W = 800, H = 180, PAD = 28;
  const maxSignups = Math.max(...data.map(d => d.signups), 1);
  const maxPosts = Math.max(...data.map(d => d.posts), 1);
  const maxReadings = Math.max(...data.map(d => d.readings), 1);
  // As tres series tem ordens de grandeza diferentes: `readings` (centenas)
  // achatava `signups` e `posts` (unidades) contra o eixo, e a legenda sugeria
  // series comparaveis. Cada uma passa a usar a propria escala — a forma da
  // curva volta a ser legivel, que e o que interessa aqui.
  const maxPorSerie: Record<string, number> = {
    signups: maxSignups || 1, posts: maxPosts || 1, readings: maxReadings || 1,
  };
  const maxAll = Math.max(maxSignups, maxPosts, maxReadings);
  const xStep = (W - PAD * 2) / Math.max(data.length - 1, 1);
  const path = (key: string) => {
    return data.map((d, i) => {
      const x = PAD + i * xStep;
      const y = H - PAD - ((d[key] || 0) / (maxPorSerie[key] || maxAll)) * (H - PAD * 2);
      return `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`;
    }).join(' ');
  };
  return (
    <div style={{
      padding: 18, borderRadius: 12,
      background: 'rgba(245,241,234,0.03)',
      border: '1px solid rgba(245,241,234,0.08)',
    }}>
      <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ display: 'block' }}>
        {/* Grid horizontal */}
        {[0.25, 0.5, 0.75].map(t => (
          <line key={t} x1={PAD} x2={W - PAD} y1={H - PAD - t * (H - PAD * 2)} y2={H - PAD - t * (H - PAD * 2)}
            stroke="rgba(245,241,234,0.06)" strokeDasharray="2,4"/>
        ))}
        <path d={path('readings')} stroke="rgba(245,241,234,0.4)" strokeWidth={1.5} fill="none"/>
        <path d={path('posts')} stroke="#E87A3B" strokeWidth={2} fill="none"/>
        <path d={path('signups')} stroke="#7DB48A" strokeWidth={2} fill="none"/>
      </svg>
      <div style={{
        display: 'flex', gap: 16, justifyContent: 'center', marginTop: 8,
        fontSize: 10, fontFamily: 'Geist Mono, monospace', letterSpacing: '0.08em',
        color: 'rgba(245,241,234,0.6)',
      }}>
        <span>● <span style={{ color: '#7DB48A' }}>signups</span></span>
        <span>● <span style={{ color: '#E87A3B' }}>posts</span></span>
        <span>● <span style={{ color: 'rgba(245,241,234,0.4)' }}>leituras</span></span>
      </div>
    </div>
  );
};

// ───────────────────────────────────────────────────────────────────
// USUÁRIOS
// ───────────────────────────────────────────────────────────────────
const UsersSection: React.FC<{ users: any[] }> = ({ users }) => (
  <div>
    <div className="mono" style={{
      fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
      color: '#E87A3B', fontWeight: 600, marginBottom: 12,
    }}>{users.length} usuários do leitura</div>
    <div style={{
      background: 'rgba(245,241,234,0.03)', borderRadius: 12,
      border: '1px solid rgba(245,241,234,0.08)', overflow: 'hidden',
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
        <thead>
          <tr style={{ background: 'rgba(245,241,234,0.04)', fontFamily: 'Geist Mono, monospace', fontSize: 10, letterSpacing: '0.10em', textTransform: 'uppercase', color: 'rgba(245,241,234,0.55)' }}>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Nome</th>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Email</th>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Plano</th>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Role</th>
            <th style={{ padding: '10px 14px', textAlign: 'right' }}>Livros</th>
            <th style={{ padding: '10px 14px', textAlign: 'right' }} title="Linhas de reading_history: cada registro de progresso de página, não sessões de leitura. O mesmo usuário gera várias no mesmo dia.">Registros</th>
            <th style={{ padding: '10px 14px', textAlign: 'right' }}>Último login</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u, i) => (
            <tr key={u.id} style={{
              borderTop: i > 0 ? '1px solid rgba(245,241,234,0.05)' : 'none',
              background: u.is_blocked ? 'rgba(232,122,59,0.06)' : 'transparent',
            }}>
              <td style={{ padding: '10px 14px' }}>
                {u.display_name || u.username}
                {u.is_blocked && <span style={{ marginLeft: 6, color: '#E87A3B', fontSize: 10 }}>· bloqueado</span>}
              </td>
              <td style={{ padding: '10px 14px', color: 'rgba(245,241,234,0.65)', fontFamily: 'Geist Mono, monospace', fontSize: 11 }}>{u.email}</td>
              <td style={{ padding: '10px 14px' }}>
                <span style={{
                  padding: '2px 8px', borderRadius: 999,
                  background: u.plan && u.plan !== 'free' ? 'rgba(232,122,59,0.18)' : 'rgba(245,241,234,0.08)',
                  color: u.plan && u.plan !== 'free' ? '#E87A3B' : 'rgba(245,241,234,0.5)',
                  fontFamily: 'Geist Mono, monospace', fontSize: 9.5, letterSpacing: '0.06em',
                }}>{PLAN_NAMES[u.plan || 'free']}</span>
              </td>
              <td style={{ padding: '10px 14px', color: u.role === 'admin' ? '#E87A3B' : 'rgba(245,241,234,0.6)', fontWeight: u.role === 'admin' ? 600 : 400 }}>
                {u.role}
              </td>
              <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace' }}>{u.books_count || 0}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace' }}>{u.history_count || 0}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace', fontSize: 10.5, color: 'rgba(245,241,234,0.55)' }}>
                {u.last_login_at ? new Date(u.last_login_at).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

// ───────────────────────────────────────────────────────────────────
// GRUPOS
// ───────────────────────────────────────────────────────────────────
const ClubsSection: React.FC<{ clubs: any[] }> = ({ clubs }) => (
  <div>
    <div className="mono" style={{
      fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
      color: '#E87A3B', fontWeight: 600, marginBottom: 12,
    }}>{clubs.length} grupos ativos</div>
    <div style={{
      background: 'rgba(245,241,234,0.03)', borderRadius: 12,
      border: '1px solid rgba(245,241,234,0.08)', overflow: 'hidden',
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
        <thead>
          <tr style={{ background: 'rgba(245,241,234,0.04)', fontFamily: 'Geist Mono, monospace', fontSize: 10, letterSpacing: '0.10em', textTransform: 'uppercase', color: 'rgba(245,241,234,0.55)' }}>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Nome</th>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Líder</th>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Modo</th>
            <th style={{ padding: '10px 14px', textAlign: 'left' }}>Privacidade</th>
            <th style={{ padding: '10px 14px', textAlign: 'right' }}>Membros</th>
            <th style={{ padding: '10px 14px', textAlign: 'right' }}>Posts</th>
            <th style={{ padding: '10px 14px', textAlign: 'right' }}>Última ativ.</th>
          </tr>
        </thead>
        <tbody>
          {clubs.map((c, i) => (
            <tr key={c.id} style={{ borderTop: i > 0 ? '1px solid rgba(245,241,234,0.05)' : 'none' }}>
              <td style={{ padding: '10px 14px' }}>{c.name}</td>
              <td style={{ padding: '10px 14px', color: 'rgba(245,241,234,0.65)', fontSize: 11 }}>{c.owner?.name || '—'}</td>
              <td style={{ padding: '10px 14px', fontFamily: 'Geist Mono, monospace', fontSize: 10, color: 'rgba(245,241,234,0.6)' }}>{c.mode}</td>
              <td style={{ padding: '10px 14px', fontFamily: 'Geist Mono, monospace', fontSize: 10, color: 'rgba(245,241,234,0.6)' }}>{c.privacy}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace' }}>{c.members}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace' }}>{c.posts}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace', fontSize: 10.5, color: 'rgba(245,241,234,0.55)' }}>
                {c.lastPostAt ? new Date(c.lastPostAt).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

// ───────────────────────────────────────────────────────────────────
// RECEITA
// ───────────────────────────────────────────────────────────────────
// ───────────────────────────────────────────────────────────────────
// INDICACOES — o funil do convite: clique -> cadastro -> ano gratis
// ───────────────────────────────────────────────────────────────────

const ReferralsSection: React.FC<{ session: any }> = ({ session }) => {
  const [d, setD] = useState<any>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    if (!session) return;
    let vivo = true;
    fetch('/api/admin/referrals', {
      headers: { Authorization: `Bearer ${session.accessToken}` },
    })
      .then((r) => r.json())
      .then((j) => { if (!vivo) return; if (j.error) setErro(j.error); else setD(j); })
      .catch((e) => { if (vivo) setErro(e?.message || 'Erro ao carregar'); })
      .finally(() => { if (vivo) setCarregando(false); });
    return () => { vivo = false; };
  }, [session]);

  if (carregando) return <div style={{ color: 'rgba(245,241,234,0.5)', fontSize: 13 }}>Carregando…</div>;
  if (erro) return <div style={{ color: '#E87A3B', fontSize: 13 }}>{erro}</div>;
  if (!d) return null;

  const r = d.resumo || {};
  const data = (iso: string | null) => iso
    ? new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }) : '—';

  const Kpi = ({ label, valor, nota }: { label: string; valor: any; nota?: string }) => (
    <div style={{
      flex: '1 1 150px', padding: '14px 16px', borderRadius: 12,
      background: 'rgba(245,241,234,0.03)', border: '1px solid rgba(245,241,234,0.08)',
    }}>
      <div className="mono" style={{
        fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase',
        color: 'rgba(245,241,234,0.45)', fontWeight: 600,
      }}>{label}</div>
      <div style={{ fontSize: 26, marginTop: 6, color: '#F5F1EA', fontWeight: 300 }}>
        {valor === null || valor === undefined ? '—' : valor}
      </div>
      {nota && <div style={{ fontSize: 10.5, color: 'rgba(245,241,234,0.4)', marginTop: 3 }}>{nota}</div>}
    </div>
  );

  const th = { padding: '10px 14px', textAlign: 'left' as const };
  const thR = { padding: '10px 14px', textAlign: 'right' as const };
  const td = { padding: '10px 14px' };
  const tdR = { padding: '10px 14px', textAlign: 'right' as const, fontFamily: 'Geist Mono, monospace' };
  const cabecalho = {
    background: 'rgba(245,241,234,0.04)', fontFamily: 'Geist Mono, monospace',
    fontSize: 10, letterSpacing: '0.10em', textTransform: 'uppercase' as const,
    color: 'rgba(245,241,234,0.55)',
  };
  const caixa = {
    background: 'rgba(245,241,234,0.03)', borderRadius: 12,
    border: '1px solid rgba(245,241,234,0.08)', overflow: 'hidden' as const,
  };

  return (
    <div>
      {/* ── funil ─────────────────────────────────────────────────── */}
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: '#E87A3B', fontWeight: 600, marginBottom: 12,
      }}>funil do convite</div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
        <Kpi label="Aberturas" valor={r.totalCliques}
             nota={r.rastreioDesde ? 'desde ' + data(r.rastreioDesde) : 'contando desde hoje'}/>
        <Kpi label="Cadastros" valor={r.totalCadastros} nota="entraram por um link"/>
        <Kpi label="Conversão" valor={r.conversao === null ? null : r.conversao + '%'}
             nota={r.conversao === null ? 'sem aberturas ainda' : 'abertura → cadastro'}/>
        <Kpi label="Ano grátis" valor={r.ganharamAnoGratis} nota="chegaram a 3 amigos"/>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 26 }}>
        <Kpi label="Links criados" valor={r.linksCriados}/>
        <Kpi label="Links com movimento" valor={r.linksAtivos}/>
        <Kpi label="Indicações válidas" valor={r.totalValidas}/>
      </div>

      {/* O rastreio de cliques nasceu em 19/08/2026. Sem este aviso, um
          "0 aberturas" parece dizer "ninguem nunca clicou", quando o certo
          e "ninguem clicou desde que passamos a contar". */}
      {!r.totalCliques && (
        <div style={{
          marginBottom: 22, padding: '11px 14px', borderRadius: 10,
          background: 'rgba(232,122,59,0.08)', border: '1px solid rgba(232,122,59,0.25)',
          fontSize: 12, color: 'rgba(245,241,234,0.72)', lineHeight: 1.5,
        }}>
          Nenhuma abertura registrada ainda. O rastreio de cliques começou em
          19/08/2026 — cadastros anteriores a essa data aparecem abaixo sem
          abertura correspondente.
        </div>
      )}

      {/* ── um card por link ──────────────────────────────────────── */}
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: 'rgba(245,241,234,0.55)', fontWeight: 600, margin: '0 0 12px',
      }}>links ({(d.links || []).length})</div>

      <div style={{ ...caixa, marginBottom: 26 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
          <thead><tr style={cabecalho}>
            <th style={th}>Dono</th>
            <th style={th}>Código</th>
            <th style={thR}>Aberturas</th>
            <th style={thR}>Cadastros</th>
            <th style={thR}>Conversão</th>
            <th style={thR}>Último clique</th>
            <th style={thR}>Ano grátis</th>
          </tr></thead>
          <tbody>
            {(d.links || []).map((l: any, i: number) => (
              <tr key={l.code} style={{
                borderTop: i > 0 ? '1px solid rgba(245,241,234,0.05)' : 'none',
                background: l.ganhouAnoGratis ? 'rgba(232,122,59,0.06)' : 'transparent',
              }}>
                <td style={td}>
                  {l.dono}
                  {l.email && <div style={{
                    fontSize: 10.5, color: 'rgba(245,241,234,0.4)',
                    fontFamily: 'Geist Mono, monospace',
                  }}>{l.email}</div>}
                </td>
                <td style={{ ...td, fontFamily: 'Geist Mono, monospace', color: '#E87A3B' }}>{l.code}</td>
                <td style={tdR}>{l.cliques}</td>
                <td style={tdR}>{l.cadastros}</td>
                <td style={{ ...tdR, color: l.conversao === null ? 'rgba(245,241,234,0.35)' : '#F5F1EA' }}>
                  {l.conversao === null ? '—' : l.conversao + '%'}
                </td>
                <td style={{ ...tdR, fontSize: 10.5, color: 'rgba(245,241,234,0.55)' }}>{data(l.ultimoClique)}</td>
                <td style={tdR}>{l.ganhouAnoGratis ? '★' : '·'}</td>
              </tr>
            ))}
            {!(d.links || []).length && (
              <tr><td colSpan={7} style={{ ...td, color: 'rgba(245,241,234,0.4)' }}>
                Nenhum link gerado ainda.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ── quem entrou pelo link de quem ─────────────────────────── */}
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: 'rgba(245,241,234,0.55)', fontWeight: 600, margin: '0 0 12px',
      }}>quem entrou pelo link de quem ({(d.quemPorQuem || []).length})</div>

      <div style={caixa}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
          <thead><tr style={cabecalho}>
            <th style={th}>Indicou</th>
            <th style={th}>Entrou</th>
            <th style={th}>Código</th>
            <th style={th}>Status</th>
            <th style={thR}>Quando</th>
          </tr></thead>
          <tbody>
            {(d.quemPorQuem || []).map((v: any, i: number) => (
              <tr key={i} style={{ borderTop: i > 0 ? '1px solid rgba(245,241,234,0.05)' : 'none' }}>
                <td style={td}>{v.indicador}</td>
                <td style={td}>{v.indicado}</td>
                <td style={{ ...td, fontFamily: 'Geist Mono, monospace', color: '#E87A3B' }}>{v.code}</td>
                <td style={td}>
                  <span style={{
                    padding: '2px 8px', borderRadius: 999,
                    background: v.status === 'valida' ? 'rgba(232,122,59,0.18)' : 'rgba(245,241,234,0.08)',
                    color: v.status === 'valida' ? '#E87A3B' : 'rgba(245,241,234,0.5)',
                    fontFamily: 'Geist Mono, monospace', fontSize: 9.5, letterSpacing: '0.06em',
                  }}>{v.status}</span>
                </td>
                <td style={{ ...tdR, fontSize: 10.5, color: 'rgba(245,241,234,0.55)' }}>{data(v.quando)}</td>
              </tr>
            ))}
            {!(d.quemPorQuem || []).length && (
              <tr><td colSpan={5} style={{ ...td, color: 'rgba(245,241,234,0.4)' }}>
                Ninguém entrou por link ainda.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const RevenueSection: React.FC<{ overview: any }> = ({ overview }) => {
  const fmtBRL = (v: number) => `R$ ${(v || 0).toFixed(2).replace('.', ',')}`;
  // Planos extintos com contagem zero saem da lista: `reader` e `reader_plus`
  // renderizavam DUAS linhas identicas "Leitor — 0 (0.0%)" (PLAN_NAMES mapeia
  // os dois para o mesmo nome), e `leader` some junto. Um plano que nao existe
  // mais e nao tem ninguem so ocupa espaco e sugere um catalogo que acabou.
  const PLANOS_EXTINTOS = ['reader', 'reader_plus', 'leader'];
  const planEntries = Object.entries(overview.revenue.planCounts || {})
    .filter(([plano, n]: any) => !(PLANOS_EXTINTOS.includes(plano) && !n));
  const totalUsers = overview.users.total || 1;
  return (
    <div>
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: '#E87A3B', fontWeight: 600, marginBottom: 12,
      }}>Receita recorrente</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
        <KPI
          label="MRR"
          value={fmtBRL(overview.revenue.mrr)}
          tooltip="Monthly Recurring Revenue (BRUTO). Soma das transações reais confirmadas no gateway, normalizadas pra mensal."
          accent
        />
        <KPI
          label="NRR"
          value={fmtBRL(overview.revenue.nrr ?? 0)}
          sub={`-${overview.revenue.feesPct ?? 0}% em taxas`}
          tooltip="Net Recurring Revenue: MRR depois de descontar as taxas do gateway. Usa o netValue da própria transação."
        />
        <KPI
          label="ARR (proj. anual)"
          value={fmtBRL(overview.revenue.arr)}
          sub={`bruto · líquido ${fmtBRL(overview.revenue.nar ?? 0)}`}
          tooltip="Annual Recurring Revenue: projeção da receita anual baseada no MRR atual. Bruto = MRR × 12. Líquido (NAR) = NRR × 12 (após descontar as taxas do gateway)."
        />
        <KPI
          label="Pagantes"
          value={overview.revenue.payingUsersReal ?? overview.revenue.payingUsers}
          sub={`${overview.revenue.conversionRate === null ? '—' : overview.revenue.conversionRate + '%'} de conversão`}
          tooltip="Pagantes reais: usuários com transação confirmada gerando MRR. Não conta admin overrides."
        />
        <KPI
          label="ARPU"
          value={(overview.revenue.payingUsersReal || 0) > 0
            ? fmtBRL(overview.revenue.mrr / overview.revenue.payingUsersReal)
            : '—'}
          tooltip="Average Revenue Per User: MRR dividido pelos pagantes REAIS. O || que caía para payingUsers foi removido: aquele número inclui admin override, então dividia receita por gente que não paga. Sem pagante real não há média — mostra '—', não R$ 0,00."
        />
      </div>

      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: '#E87A3B', fontWeight: 600, marginTop: 28, marginBottom: 12,
      }}>Distribuição de planos</div>

      {/* A barra laranja mede ACESSO, nao receita. Sem este aviso, 84% de
          admin override parece 84% de gente pagando — e o aviso equivalente
          so existia na aba Visao Geral, que nao e onde se olha esta barra. */}
      {(overview.revenue.payingUsersGranted || 0) > 0 && (
        <div style={{
          marginBottom: 12, padding: '10px 13px', borderRadius: 10,
          background: 'rgba(232,122,59,0.08)', border: '1px solid rgba(232,122,59,0.25)',
          fontSize: 11.5, color: 'rgba(245,241,234,0.72)', lineHeight: 1.5,
        }}>
          Isto é distribuição de <strong style={{ color: '#F5F1EA' }}>acesso</strong>, não de receita.
          {' '}{overview.revenue.payingUsersGranted} destes têm plano concedido pelo admin, sem cobrança.
          {' '}Pagantes de verdade: <strong style={{ color: '#F5F1EA' }}>{overview.revenue.payingUsersReal ?? 0}</strong>.
        </div>
      )}
      <div style={{
        background: 'rgba(245,241,234,0.03)', borderRadius: 12,
        border: '1px solid rgba(245,241,234,0.08)', padding: 18,
      }}>
        {planEntries.map(([plan, count]: any) => {
          const pct = totalUsers > 0 ? (count / totalUsers) * 100 : 0;
          const isPaid = plan !== 'free';
          return (
            <div key={plan} style={{ marginBottom: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <span style={{ fontSize: 12.5, color: '#F5F1EA' }}>{PLAN_NAMES[plan]}</span>
                <span className="mono" style={{ fontSize: 11, color: 'rgba(245,241,234,0.6)' }}>
                  {count} ({pct.toFixed(1)}%)
                </span>
              </div>
              <div style={{ height: 6, background: 'rgba(245,241,234,0.08)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{
                  height: '100%',
                  width: `${pct}%`,
                  background: isPaid ? '#E87A3B' : 'rgba(245,241,234,0.3)',
                  borderRadius: 3,
                  transition: 'width 600ms cubic-bezier(0.22, 1, 0.36, 1)',
                }}/>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ───────────────────────────────────────────────────────────────────
// PLANOS — editor de preços e features (admin altera, paywall reflete)
// ───────────────────────────────────────────────────────────────────
const PlansSection: React.FC<{ session: any }> = ({ session }) => {
  const [plans, setPlans] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState<string | null>(null);
  const [savedId, setSavedId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await api.adminListPlans(session);
      setPlans(r.plans || []);
    } catch (e: any) {
      setError(e?.message || 'Erro ao carregar');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [session]);

  const handleSave = async (planId: string, patch: any) => {
    setSavingId(planId);
    setError(null);
    try {
      const r = await api.adminUpdatePlan(session, planId, patch);
      setPlans(prev => prev.map(p => p.planId === planId ? r.plan : p));
      setSavedId(planId);
      setTimeout(() => setSavedId(null), 1800);
    } catch (e: any) {
      setError(e?.message || 'Erro ao salvar');
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div>
      <div className="mono" style={{
        fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
        color: '#E87A3B', fontWeight: 600, marginBottom: 12,
      }}>Planos · {plans.length} configurados</div>
      <div style={{ fontSize: 12.5, color: 'rgba(245,241,234,0.55)', marginBottom: 18, maxWidth: 700, lineHeight: 1.5 }}>
        Edite preços, badges de desconto e features que aparecem no paywall. Mudanças refletem no app dos usuários após o próximo refresh do paywall.
      </div>

      {error && (
        <div style={{
          padding: 12, borderRadius: 10, marginBottom: 16,
          background: 'rgba(232,122,59,0.15)',
          border: '1px solid rgba(232,122,59,0.4)',
          color: '#E87A3B', fontSize: 13,
        }}>{error}</div>
      )}

      {loading && (
        <div style={{ padding: 30, textAlign: 'center', color: 'rgba(245,241,234,0.5)', fontSize: 12.5 }}>
          Carregando planos…
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {plans.map(p => (
          <PlanEditor
            key={p.planId}
            plan={p}
            saving={savingId === p.planId}
            saved={savedId === p.planId}
            onSave={(patch) => handleSave(p.planId, patch)}
          />
        ))}
      </div>
    </div>
  );
};

// Editor inline de UM plano — campos editáveis, salvar individual
const PlanEditor: React.FC<{
  plan: any;
  saving: boolean;
  saved: boolean;
  onSave: (patch: any) => void;
}> = ({ plan, saving, saved, onSave }) => {
  const [displayName, setDisplayName] = useState(plan.displayName || '');
  const [tagline, setTagline] = useState(plan.tagline || '');
  const [group, setGroup] = useState(plan.group || 'reader');
  const [monthPrice, setMonthPrice] = useState(String(plan.monthPrice ?? 0));
  const [yearPrice, setYearPrice] = useState(String(plan.yearPrice ?? 0));
  const [discountLabel, setDiscountLabel] = useState(plan.discountLabel || '');
  const [features, setFeatures] = useState<string[]>(plan.features || []);
  const [pixOnYear, setPixOnYear] = useState((plan.yearMethods || []).includes('pix'));
  const [pixOnMonth, setPixOnMonth] = useState((plan.monthMethods || []).includes('pix'));
  const [isActive, setIsActive] = useState(plan.isActive !== false);

  // Re-sincroniza quando o plan vem novo (após save) — pra não preservar drafts antigos
  useEffect(() => {
    setDisplayName(plan.displayName || '');
    setTagline(plan.tagline || '');
    setGroup(plan.group || 'reader');
    setMonthPrice(String(plan.monthPrice ?? 0));
    setYearPrice(String(plan.yearPrice ?? 0));
    setDiscountLabel(plan.discountLabel || '');
    setFeatures(plan.features || []);
    setPixOnYear((plan.yearMethods || []).includes('pix'));
    setPixOnMonth((plan.monthMethods || []).includes('pix'));
    setIsActive(plan.isActive !== false);
  }, [plan.updatedAt]);

  const handleSubmit = () => {
    onSave({
      displayName, tagline, group,
      monthPrice: parseFloat(monthPrice) || 0,
      yearPrice: parseFloat(yearPrice) || 0,
      discountLabel: discountLabel.trim() || null,
      features: features.filter(f => f && f.trim().length > 0),
      monthMethods: pixOnMonth ? ['card', 'pix'] : ['card'],
      yearMethods: pixOnYear ? ['card', 'pix'] : ['card'],
      isActive,
    });
  };

  const monthlyEq = (parseFloat(yearPrice) || 0) / 12;

  return (
    <div style={{
      padding: 20, borderRadius: 14,
      background: isActive ? 'rgba(245,241,234,0.04)' : 'rgba(245,241,234,0.02)',
      border: '1px solid ' + (saved ? 'rgba(74,138,90,0.5)' : 'rgba(245,241,234,0.08)'),
      transition: 'border-color 200ms',
      opacity: isActive ? 1 : 0.6,
    }}>
      {/* Header com plan_id e status */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 16 }}>
        <div>
          <div className="mono" style={{
            fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase',
            color: 'rgba(245,241,234,0.45)',
          }}>{plan.planId}</div>
          <div className="serif" style={{ fontSize: 22, lineHeight: 1.1, marginTop: 4, color: '#F5F1EA' }}>
            {displayName || '—'}
          </div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 12, color: 'rgba(245,241,234,0.7)' }}>
          <input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} style={{ width: 14, height: 14, cursor: 'pointer' }}/>
          Ativo
        </label>
      </div>

      {/* Grid de campos editáveis */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 12,
      }}>
        <Field label="Nome de display">
          <input value={displayName} onChange={e => setDisplayName(e.target.value)} style={inputStyle}/>
        </Field>
        <Field label="Tagline (subtítulo)">
          <input value={tagline} onChange={e => setTagline(e.target.value)} style={inputStyle}/>
        </Field>
        <Field label="Grupo">
          <select value={group} onChange={e => setGroup(e.target.value)} style={inputStyle}>
            <option value="reader">Pra leitores</option>
            <option value="leader">Pra criadores</option>
          </select>
        </Field>
        <Field label="Badge de desconto">
          <input value={discountLabel} onChange={e => setDiscountLabel(e.target.value)} placeholder="ex: −40%" style={inputStyle}/>
        </Field>
        <Field label={`Preço mensal (R$)`}>
          <input type="number" step="0.01" min="0" value={monthPrice} onChange={e => setMonthPrice(e.target.value)} style={inputStyle}/>
        </Field>
        <Field label={`Preço anual (R$)  · ≈ R$ ${monthlyEq.toFixed(2).replace('.', ',')}/mês`}>
          <input type="number" step="0.01" min="0" value={yearPrice} onChange={e => setYearPrice(e.target.value)} style={inputStyle}/>
        </Field>
      </div>

      {/* Métodos de pagamento por período */}
      <div style={{ marginTop: 14, display: 'flex', gap: 18, fontSize: 12, color: 'rgba(245,241,234,0.7)' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
          <input type="checkbox" checked={pixOnMonth} onChange={e => setPixOnMonth(e.target.checked)} style={{ width: 14, height: 14 }}/>
          Mensal aceita Pix
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
          <input type="checkbox" checked={pixOnYear} onChange={e => setPixOnYear(e.target.checked)} style={{ width: 14, height: 14 }}/>
          Anual aceita Pix
        </label>
      </div>

      {/* Features (lista editável) */}
      <div style={{ marginTop: 16 }}>
        <div className="mono" style={{
          fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase',
          color: 'rgba(245,241,234,0.45)', marginBottom: 8,
        }}>Features destacadas no paywall</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {features.map((f, i) => (
            <div key={i} style={{ display: 'flex', gap: 6 }}>
              <input
                value={f}
                onChange={e => {
                  const next = [...features];
                  next[i] = e.target.value;
                  setFeatures(next);
                }}
                style={{ ...inputStyle, flex: 1 }}
              />
              <button
                onClick={() => setFeatures(features.filter((_, j) => j !== i))}
                style={{
                  width: 32, height: 32, borderRadius: 8,
                  background: 'transparent', border: '1px solid rgba(245,241,234,0.15)',
                  color: 'rgba(245,241,234,0.5)', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit',
                }}
                title="Remover feature"
              >×</button>
            </div>
          ))}
          {features.length < 12 && (
            <button
              onClick={() => setFeatures([...features, ''])}
              style={{
                padding: '8px 12px', borderRadius: 8,
                background: 'transparent', border: '1px dashed rgba(245,241,234,0.18)',
                color: 'rgba(245,241,234,0.6)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
                alignSelf: 'flex-start',
              }}
            >+ Adicionar feature</button>
          )}
        </div>
      </div>

      {/* CTA salvar */}
      <div style={{ marginTop: 18, display: 'flex', gap: 10, alignItems: 'center' }}>
        <button
          onClick={handleSubmit}
          disabled={saving}
          style={{
            padding: '10px 20px', borderRadius: 10,
            background: saved ? 'rgba(74,138,90,0.25)' : '#E87A3B',
            border: 'none', color: saved ? '#7DB48A' : '#F5F1EA',
            fontSize: 13, fontWeight: 600, cursor: saving ? 'default' : 'pointer',
            opacity: saving ? 0.6 : 1, fontFamily: 'inherit',
          }}>
          {saving ? 'Salvando…' : saved ? '✓ Salvo' : 'Salvar plano'}
        </button>
        <span className="mono" style={{ fontSize: 10, color: 'rgba(245,241,234,0.4)', letterSpacing: '0.06em' }}>
          atualizado {plan.updatedAt ? new Date(plan.updatedAt).toLocaleString('pt-BR', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' }) : '—'}
        </span>
      </div>
    </div>
  );
};

const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', borderRadius: 8,
  background: 'rgba(245,241,234,0.06)',
  border: '1px solid rgba(245,241,234,0.12)',
  color: '#F5F1EA', fontSize: 13, outline: 'none',
  fontFamily: 'inherit', boxSizing: 'border-box',
};

const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
    <label className="mono" style={{
      fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase',
      color: 'rgba(245,241,234,0.5)', fontWeight: 600,
    }}>{label}</label>
    {children}
  </div>
);

// ───────────────────────────────────────────────────────────────────
// COBRANÇAS — log de cobrança (webhook + status das assinaturas)
// ───────────────────────────────────────────────────────────────────
//
// Lista os subscription_events registrados pelo backend cada vez que o gateway
// dispara um webhook (PAYMENT_CONFIRMED, OVERDUE, SUBSCRIPTION_DELETED…).
// Útil pra Wesley acompanhar:
//   - quem ativou plano e quando
//   - cobranças vencidas / inadimplência
//   - cancelamentos / chargebacks
//
// Filtros locais por tipo de evento + busca por email (assumindo que o backend
// retornar email junto, ou pelo menos user_id pra cruzar).
const BillingSection: React.FC<{ session: any }> = ({ session }) => {
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filter, setFilter] = useState<string>('all');

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await api.adminListSubscriptionEvents(session, 200);
      setEvents(r.events || []);
    } catch (e: any) {
      setError(e?.message || 'Erro ao carregar eventos');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [session]);

  // Tipos de evento comuns — agrupamos pra filtro rápido
  const KIND_GROUPS: Array<{ key: string; label: string; types: string[] | null; tone: string }> = [
    { key: 'all',       label: 'Todos',          types: null, tone: 'rgba(245,241,234,0.6)' },
    { key: 'confirmed', label: 'Confirmados',    types: ['PAYMENT_CONFIRMED', 'PAYMENT_RECEIVED'], tone: '#7DB48A' },
    { key: 'pending',   label: 'Pendentes',      types: ['PAYMENT_CREATED', 'PAYMENT_AWAITING_RISK_ANALYSIS'], tone: '#E0B86C' },
    { key: 'overdue',   label: 'Inadimplentes',  types: ['PAYMENT_OVERDUE'], tone: '#E87A3B' },
    { key: 'cancelled', label: 'Cancelados', types: ['SUBSCRIPTION_CANCELLED', 'PAYMENT_DELETED', 'PAYMENT_REFUNDED', 'PAYMENT_CHARGEBACK'], tone: 'danger' },
  ];

  const filtered = filter === 'all'
    ? events
    : events.filter(e => {
        const grp = KIND_GROUPS.find(g => g.key === filter);
        return grp?.types?.includes(e.event_type);
      });

  const fmtBRL = (v: any) => v != null ? `R$ ${Number(v).toFixed(2).replace('.', ',')}` : '—';
  const fmtDate = (s: string) => s ? new Date(s).toLocaleString('pt-BR', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' }) : '—';
  const eventToneFor = (type: string) => {
    if (type?.includes('CONFIRMED') || type?.includes('RECEIVED')) return { bg: 'rgba(74,138,90,0.18)', fg: '#7DB48A' };
    if (type?.includes('OVERDUE')) return { bg: 'rgba(232,122,59,0.18)', fg: '#E87A3B' };
    if (type?.includes('DELETED') || type?.includes('REFUND') || type?.includes('CHARGEBACK')) return { bg: 'rgba(245,241,234,0.08)', fg: 'rgba(245,241,234,0.5)' };
    return { bg: 'rgba(224,184,108,0.14)', fg: '#E0B86C' };
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap', gap: 12 }}>
        <div className="mono" style={{
          fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
          color: '#E87A3B', fontWeight: 600,
        }}>Cobranças · {events.length} eventos no histórico</div>
        <button onClick={load} disabled={loading} style={{
          padding: '6px 12px', borderRadius: 999,
          background: 'transparent', border: '1px solid rgba(245,241,234,0.15)',
          color: 'rgba(245,241,234,0.7)', fontSize: 11, cursor: loading ? 'default' : 'pointer',
          fontFamily: 'inherit',
        }}>
          {loading ? '…' : '↻ recarregar'}
        </button>
      </div>

      <div style={{ fontSize: 12.5, color: 'rgba(245,241,234,0.55)', marginBottom: 16, maxWidth: 720, lineHeight: 1.5 }}>
        Eventos disparados pelo gateway via webhook. Cada cobrança confirmada aqui ativa o plano do usuário.
        Eventos sem <code style={{ background: 'rgba(245,241,234,0.06)', padding: '0 4px', borderRadius: 3 }}>user_id</code> resolvido geralmente são webhooks de teste ou clientes criados fora do app.
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
        {KIND_GROUPS.map(g => {
          const active = filter === g.key;
          const count = g.types == null ? events.length : events.filter(e => g.types!.includes(e.event_type)).length;
          return (
            <button
              key={g.key}
              onClick={() => setFilter(g.key)}
              style={{
                padding: '6px 12px', borderRadius: 999,
                background: active ? 'rgba(232,122,59,0.18)' : 'rgba(245,241,234,0.04)',
                border: '1px solid ' + (active ? 'rgba(232,122,59,0.4)' : 'rgba(245,241,234,0.1)'),
                color: active ? '#E87A3B' : 'rgba(245,241,234,0.7)',
                fontSize: 11.5, cursor: 'pointer', fontFamily: 'inherit',
                display: 'flex', alignItems: 'center', gap: 6,
              }}
            >
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: g.tone }}/>
              {g.label}
              <span style={{ opacity: 0.7, fontFamily: 'Geist Mono, monospace', fontSize: 10 }}>{count}</span>
            </button>
          );
        })}
      </div>

      {error && (
        <div style={{
          padding: 12, borderRadius: 10, marginBottom: 16,
          background: 'rgba(232,122,59,0.15)',
          border: '1px solid rgba(232,122,59,0.4)',
          color: '#E87A3B', fontSize: 13,
        }}>{error}</div>
      )}

      {loading && events.length === 0 && (
        <div style={{ padding: 30, textAlign: 'center', color: 'rgba(245,241,234,0.5)', fontSize: 12.5 }}>
          Carregando eventos…
        </div>
      )}

      {!loading && events.length === 0 && !error && (
        <div style={{
          padding: 40, textAlign: 'center',
          background: 'rgba(245,241,234,0.03)', borderRadius: 14,
          border: '1px dashed rgba(245,241,234,0.15)',
        }}>
          <div style={{ fontSize: 32, marginBottom: 10 }}>💸</div>
          <div className="serif" style={{ fontSize: 18, color: '#F5F1EA', marginBottom: 6 }}>
            Nenhum evento ainda
          </div>
          <div style={{ fontSize: 12.5, color: 'rgba(245,241,234,0.55)', maxWidth: 460, margin: '0 auto', lineHeight: 1.5 }}>
            Quando alguém ativar um plano e o pagamento for confirmado, vai cair aqui —
            pelo Mercado Pago ou pelas lojas.
            No servidor, confira <code style={{ background: 'rgba(245,241,234,0.06)', padding: '0 4px', borderRadius: 3 }}>MP_ENABLED=true</code> com <code style={{ background: 'rgba(245,241,234,0.06)', padding: '0 4px', borderRadius: 3 }}>MP_ACCESS_TOKEN</code> e <code style={{ background: 'rgba(245,241,234,0.06)', padding: '0 4px', borderRadius: 3 }}>MP_WEBHOOK_SECRET</code>, e o <code style={{ background: 'rgba(245,241,234,0.06)', padding: '0 4px', borderRadius: 3 }}>REVENUECAT_WEBHOOK_TOKEN</code> pras lojas.
          </div>
        </div>
      )}

      {filtered.length > 0 && (
        <div style={{
          background: 'rgba(245,241,234,0.03)', borderRadius: 12,
          border: '1px solid rgba(245,241,234,0.08)', overflow: 'hidden',
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
            <thead>
              <tr style={{ background: 'rgba(245,241,234,0.04)', fontFamily: 'Geist Mono, monospace', fontSize: 10, letterSpacing: '0.10em', textTransform: 'uppercase', color: 'rgba(245,241,234,0.55)' }}>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Quando</th>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Evento</th>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Usuário</th>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Plano</th>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Período</th>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Método</th>
                <th style={{ padding: '10px 14px', textAlign: 'right' }}>Valor</th>
                <th style={{ padding: '10px 14px', textAlign: 'left' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((ev, i) => {
                const tone = eventToneFor(ev.event_type);
                return (
                  <tr key={ev.id || i} style={{ borderTop: i > 0 ? '1px solid rgba(245,241,234,0.05)' : 'none' }}>
                    <td style={{ padding: '10px 14px', fontFamily: 'Geist Mono, monospace', fontSize: 11, color: 'rgba(245,241,234,0.7)', whiteSpace: 'nowrap' }}>
                      {fmtDate(ev.created_at)}
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <span style={{
                        padding: '2px 8px', borderRadius: 999,
                        background: tone.bg, color: tone.fg,
                        fontFamily: 'Geist Mono, monospace', fontSize: 9.5,
                        letterSpacing: '0.06em', whiteSpace: 'nowrap',
                      }}>{ev.event_type}</span>
                    </td>
                    <td style={{ padding: '10px 14px', fontSize: 11.5, color: 'rgba(245,241,234,0.85)' }}>
                      {ev.userEmail || ev.userName || (ev.user_id ? <code style={{ fontFamily: 'Geist Mono, monospace', fontSize: 10, color: 'rgba(245,241,234,0.5)' }}>{String(ev.user_id).slice(0, 8)}…</code> : <span style={{ color: 'rgba(245,241,234,0.4)' }}>—</span>)}
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      {ev.plan_id ? (
                        <span style={{
                          padding: '2px 8px', borderRadius: 999,
                          background: 'rgba(232,122,59,0.12)', color: '#E87A3B',
                          fontFamily: 'Geist Mono, monospace', fontSize: 10, letterSpacing: '0.06em',
                        }}>{PLAN_NAMES[ev.plan_id] || ev.plan_id}</span>
                      ) : <span style={{ color: 'rgba(245,241,234,0.4)' }}>—</span>}
                    </td>
                    <td style={{ padding: '10px 14px', fontFamily: 'Geist Mono, monospace', fontSize: 10.5, color: 'rgba(245,241,234,0.6)' }}>
                      {ev.billing_period === 'year' ? 'anual' : ev.billing_period === 'month' ? 'mensal' : '—'}
                    </td>
                    <td style={{ padding: '10px 14px', fontFamily: 'Geist Mono, monospace', fontSize: 10.5, color: 'rgba(245,241,234,0.6)' }}>
                      {(() => {
                        // O webhook grava CREDIT_CARD/PIX em maiusculo; comparar
                        // com minusculo fazia toda cobranca real virar "—".
                        const m = String(ev.payment_method || '').toLowerCase();
                        if (m.includes('pix')) return '💸 pix';
                        if (m.includes('card') || m.includes('credit')) return '💳 cartão';
                        return '—';
                      })()}
                    </td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'Geist Mono, monospace', fontSize: 11.5, color: tone.fg, fontWeight: 600 }}>
                      {fmtBRL(ev.amount)}
                    </td>
                    <td style={{ padding: '10px 14px', fontFamily: 'Geist Mono, monospace', fontSize: 10, color: 'rgba(245,241,234,0.55)' }}>
                      {ev.status || '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {filter !== 'all' && filtered.length === 0 && events.length > 0 && (
        <div style={{
          padding: 24, textAlign: 'center',
          background: 'rgba(245,241,234,0.02)', borderRadius: 12,
          border: '1px solid rgba(245,241,234,0.06)',
          color: 'rgba(245,241,234,0.5)', fontSize: 12.5,
        }}>
          Nenhum evento desse tipo ainda.
        </div>
      )}
    </div>
  );
};

// ───────────────────────────────────────────────────────────────────
// SUPORTE (placeholder)
// ───────────────────────────────────────────────────────────────────
const SupportSection: React.FC = () => (
  <div style={{
    padding: 40, textAlign: 'center',
    background: 'rgba(245,241,234,0.03)', borderRadius: 14,
    border: '1px dashed rgba(245,241,234,0.15)',
  }}>
    <div style={{ fontSize: 36, marginBottom: 12 }}>🛟</div>
    <div className="serif" style={{ fontSize: 22, color: '#F5F1EA', marginBottom: 8 }}>
      Suporte · em breve
    </div>
    <div style={{ fontSize: 12.5, color: 'rgba(245,241,234,0.55)', maxWidth: 420, margin: '0 auto', lineHeight: 1.5 }}>
      Reclamações, alertas de push falhados, erros do log, tickets abertos pelos usuários.
      Vamos plugar quando tivermos o canal de suporte estabelecido.
    </div>
  </div>
);
